import { Component, DestroyRef, inject, Injectable, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { BUILD_DATE } from '../build-info';
import { ConsentService } from '../consent';
import { UserService } from '../user.service';

/** Whether a footer is on screen, so the site menu can carry its legal links when it isn't (e.g. in chat). */
@Injectable({ providedIn: 'root' })
export class FooterPresence {
  readonly visible = signal(0);
}

@Component({
  selector: 'app-footer',
  imports: [RouterLink, DatePipe],
  templateUrl: './footer.html',
  styleUrls: ['./footer.scss'],
})
export class Footer {
  users = inject(UserService);
  consent = inject(ConsentService);
  buildDate = BUILD_DATE;
  year = new Date().getFullYear();

  constructor() {
    const presence = inject(FooterPresence);
    presence.visible.update((n) => n + 1);
    inject(DestroyRef).onDestroy(() => presence.visible.update((n) => n - 1));
  }
}
